const Appdispute = () =>
    import('@/module/index/layout/Appdispute.vue')
const tempPeo = () =>
    import('@/module/index/pages/tempUser/tempPeo.vue')
const tempAdmin = () =>
    import('@/module/index/pages/tempUser/tempAdmin.vue')

export default {
  path: '/',
  component: Appdispute,
  meta: {
    title: ''
  },
  children: [{
    path: '/tempPeo/:stepId/:disputeId', // 案管系统模板--人民调解
    name: 'tempPeo',
    component: tempPeo
  },
  {
    path: '/tempAdmin/:stepId/:disputeId', // 案管系统模板--行政调解
    name: 'tempAdmin',
    component: tempAdmin
  }
  ]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/tempMediation.js